import React from 'react';
import { IconLabelProps } from '../IconLabel';
import { PrivacySection as RawPrivacySection } from '../../../components/landingPage/PrivacySection';
import { PrivacyItem as RawPrivacyLabel } from '../../../components/landingPage/PrivacyItem';
import { SanityObject } from '../../../lib/landingPage';
import { ButtonLink, ButtonLinkProps } from '../Link';
import { Wrapper } from '../Wrapper';
import { Icon } from '../Icon';
import { observer } from 'mobx-react-lite';

export type PrivacySectionProps = {
    title: string;
    labels: SanityObject<PrivacyLabelProps>[];
};

type PrivacyLabelProps = {
    link: SanityObject<ButtonLinkProps>;
    iconLabel: SanityObject<IconLabelProps>;
};

const PrivacyLabel = Wrapper(
    ({ link, iconLabel: { icon, text } }: PrivacyLabelProps) => {
        return (
            <RawPrivacyLabel
                icon={<Icon value={icon} />}
                text={text}
                link={<ButtonLink value={link} />}
            />
        );
    },
    'privacyIconLabel'
);

const PrivacySectionInternal = observer((p: PrivacySectionProps) => {
    return (
        <RawPrivacySection title={p.title} stroke="spiral">
            {p.labels.map((label, idx) => (
                <PrivacyLabel value={label} key={idx} />
            ))}
        </RawPrivacySection>
    );
});

export const PrivacySection = Wrapper((p: PrivacySectionProps): JSX.Element => {
    return <PrivacySectionInternal {...p} />;
}, 'privacySection');
